<template>
  <div class="paymentForm">
    <p class="town-card__img">
      <img height="24" src="/static/img/academy/credit_brand1.png" alt="card">
    </p>
    <form-credit-card
      label="カード番号"
      name="cc_number"
      data-vv-name="cc_number"
      data-vv-value-path="formattedValue"
      v-model="ccNumber"
      placeholder="例）1234 5678 9123 4567"
      :validation="{ rules: {
        required: true,
        credit_card: true
      } }"
    />
    <form-credit-expire
      name=""
      label="カード有効期限"
      month-name="cc_expiration_m"
      year-name="cc_expiration_y"
      :validation="{ rules: {
        required: true
        } }"
      v-model="ccExpiration"
    />
    <form-security-code v-model="securityCode" />
    <base-button
      class="paymentRegistForm__button"
      text="登録"
      :disabled="buttonIsDisabled || lock"
      @click="updateCardData"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import BaseButton from '@/utvStore/components/Academy/partials/BaseButton'

export default {
  name: 'payment-form',
  components:{
    BaseButton,
  },
  data() {
    return {
      lock: false,
      ccNumber: '',
      ccExpiration: '',
      securityCode: '',
      buttonIsDisabled: false,
      validateFlags: {},
    }
  },
  props: {
    merchantId: String,
    serviceId: String,
    userId: String,
    academyAccessToken: String,
  },
  mounted(){
    this.validateFlags = this.$validator.flags
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    }
  },
  methods: {
    updateCardData() {
      if (!window.com_sbps_system) throw new Error('Error: window.com_sbps_system がありません。')
      const data = {
        merchantId: this.merchantId,
        serviceId: this.serviceId,
        ccNumber: this.ccNumber,
        ccExpiration: `20${this.ccExpiration.year}${
          this.ccExpiration.month
        }`,
        securityCode: this.securityCode
      }
      this.lock = true
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    afterGenerateToken(response) {
      const messageParam = { duration: 5000, showClose: true }
      if (response.result == 'OK') {
        const { tokenResponse } = response
        this.$store.dispatch(type.UPDATE_PAYMENT_INFO_ACADEMY, {
          userId: this.userId,
          token: tokenResponse.token,
          tokenKey: tokenResponse.tokenKey
        }).then((res) => {
          this.$message({ message: 'お支払い情報を更新しました。', type: 'success', ...messageParam })
        }).then(() => {
          window.location.href = `/academy/status/${this.academyAccessToken}`
        }).catch((res) => {
          this.$message({ message: `${res.errorTitle}\n${res.errorMessage}`, type: 'warning', ...messageParam })
          this.lock = false
        })
      } else {
        this.$message({ message: '登録に失敗しました。', type: 'warning', ...messageParam })
        this.lock = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';

.paymentForm{
  &__title {
    width: 61.538%;
    max-width: 270px;
    vertical-align: middle;
  }
  .baseButton {
    margin-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/pages/PaymentForm.vue